import { useAccountUpdateAlertSubscription } from '@frameio/graphql-client/generated';
import { useActiveAccountId } from '@frameio/shared/contexts';

export function AccountUpdateAlertSubscription() {
  const accountId = useActiveAccountId();

  useAccountUpdateAlertSubscription({
    variables: { scope: { refreshRequired: { accountId } } },
    skip: !accountId,
  });

  return null;
}
